import React from 'react';
import FeaturedEventItem from './FeaturedEventItem';

export default function FeaturedList({ featuredEvents, isLoading }) {
  return (
    <div>
      {featuredEvents.length > 0 ? (
        <section
          className={`section u--padding-bottom-15 ${
            isLoading ? 'opacity-50' : ''
          }`}
        >
          <div className="container container--xl">
            <div className="grid grid--std">
              <div className="featured-events grid__col-lg-8 u--margin-bottom-0">
                <div className="section__header">
                  <h4 className="section__header-text">Featured Events</h4>
                </div>
                <div className="featured-events__list">
                  {featuredEvents &&
                    featuredEvents.map((featuredEvent) => (
                      <FeaturedEventItem
                        key={featuredEvent.id}
                        featuredEvent={featuredEvent}
                      />
                    ))}
                </div>
              </div>
              <div className="grid__col-lg-4"></div>
            </div>
          </div>
        </section>
      ) : (
        ''
      )}
    </div>
  );
}
